import { render } from "./BpmnGateway.vue?vue&type=template&id=31cfd45a&scoped=true"
import script from "./BpmnGateway.vue?vue&type=script&lang=js"
export * from "./BpmnGateway.vue?vue&type=script&lang=js"

import "./BpmnGateway.vue?vue&type=style&index=0&id=31cfd45a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cfd45a"]])

export default __exports__